/* eslint-disable react/destructuring-assignment */
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/diag/printprops'
import useGolfFacilitiesDataSourceEnabled from '@lib/feature-flags/useGolfFacilitiesDataSourceEnabled'
import CoursesInState from './courses-in-state'

export const COURSES_IN_STATE_QUERY = gql`
query FacilitiesByState($state: String!) {
  listCities(stateCode: $state) {
    city
    courseCount
  }
}
`

export default function CoursesInStateWithData(props) {
  const { ssrData, ...query } = props
  const golfFacilitiesDataSource = useGolfFacilitiesDataSourceEnabled()

  if (ssrData !== undefined) {
    return (
      <CoursesInState
        stateCode={query.state}
        cities={ssrData || []}
      />
    )
  }

  if (golfFacilitiesDataSource) {
    return (
      <CoursesInState
        stateCode={query.state}
        cities={[]}
      />
    )
  }

  return (
    <Query query={COURSES_IN_STATE_QUERY} variables={query} context={{ clientName: 'pga-algolia' }}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />
        const response = data.listCities

        return (
          <CoursesInState
            stateCode={query.state}
            cities={response}
          />
        )
      }}
    </Query>
  )
}

CoursesInStateWithData.propTypes = {
  state: PropTypes.string,
  ssrData: PropTypes.array,
}
